module.exports = __webpack_public_path__ + "img/titanium.57f053cc.svg";